"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Header = _styledComponents.default.div.withConfig({
  displayName: "Tabs__Header",
  componentId: "huqay-0"
})(["display:flex;margin-bottom:8px;flex-shrink:0;"]);

const HeaderItem = _styledComponents.default.div.withConfig({
  displayName: "Tabs__HeaderItem",
  componentId: "huqay-1"
})([" ", ""], p => (0, _styledComponents.css)(["border-bottom:4px solid transparent;cursor:pointer;padding:8px 16px;", ";", ";&:hover{", ";}"], p => p.theme.transition, p.active && (0, _styledComponents.css)(["border-bottom-color:", ";"], p.theme.colors.main), !p.active && (0, _styledComponents.css)(["border-bottom-color:#dfdfdf;"])));

const TabsContent = _styledComponents.default.div.withConfig({
  displayName: "Tabs__TabsContent",
  componentId: "huqay-2"
})(["flex:1;display:flex;flex-direction:column;overflow:hidden;"]);

const TabContent = _styledComponents.default.div.withConfig({
  displayName: "Tabs__TabContent",
  componentId: "huqay-3"
})([" ", ""], p => (0, _styledComponents.css)(["", ";display:", ";top:0;left:0;width:100%;height:100%;background:#fff;flex-direction:column;overflow:hidden;overflow-y:auto;flex-shrink:0;"], p.theme.transition, p.active ? 'flex' : 'none'));

const Tabs = ({
  className,
  select = 0,
  selectByName,
  tabsContentRef,
  focusFirstInputOnSelect,
  onSelect,
  children
}) => {
  const [selectedIdx, setSelectedIdx] = (0, _react.useState)(select);
  const tabContentRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (focusFirstInputOnSelect) {
      setTimeout(selectFirstInput);
    }
  }, [selectedIdx]);
  (0, _react.useEffect)(() => {
    if (!selectByName) {
      return;
    }

    const idx = _react.default.Children.toArray(children).findIndex(child => {
      var _child$props;

      return (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.name) === selectByName;
    });

    setSelectedIdx(idx);
  }, [selectByName]);

  const selectFirstInput = () => {
    var _el;

    const ref = tabContentRef === null || tabContentRef === void 0 ? void 0 : tabContentRef.current;

    if (!ref) {
      return;
    }

    let el = ref.querySelector('input');

    if (!el) {
      el = ref.querySelector('textarea');
    }

    (_el = el) === null || _el === void 0 ? void 0 : _el.focus();
  };

  const isSelected = idx => {
    return selectedIdx === idx;
  };

  const selectTab = (idx, name) => () => {
    setSelectedIdx(idx);
    onSelect(idx, name);
  };

  const renderHeader = () => {
    return /*#__PURE__*/_react.default.createElement(Header, null, _react.default.Children.map(children, (child, idx) => {
      if (!child) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(HeaderItem, {
        key: idx,
        active: isSelected(idx),
        onClick: selectTab(idx, child.props.name)
      }, child.props.label);
    }));
  };

  const renderTabs = () => {
    return /*#__PURE__*/_react.default.createElement(TabsContent, {
      ref: tabsContentRef
    }, _react.default.Children.map(children, (child, idx) => {
      if (!child) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(TabContent, {
        key: idx,
        active: isSelected(idx),
        ref: isSelected(idx) ? tabContentRef : null
      }, child.props.children);
    }));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, renderHeader(), renderTabs());
};

Tabs.defaultProps = {
  onSelect: () => {}
};

var _default = (0, _styledComponents.default)(Tabs).withConfig({
  displayName: "Tabs",
  componentId: "huqay-4"
})(["flex:1;display:flex;flex-direction:column;overflow:hidden;"]);

exports.default = _default;